module.exports = __webpack_public_path__ + "img/art4-img5.b7e02d3f.jpeg";